import { CanDeactivateFn } from '@angular/router';
import { ConfirmsLeave } from './unsaved-changes-form';

/** Every form route: leaving by Cancel, the side nav, breadcrumbs or Back asks Unsaved Changes when anything changed. */
export const unsavedChangesGuard: CanDeactivateFn<ConfirmsLeave> = (page) => page?.confirmLeave?.() ?? true;
